import * as types from 'containers/csboard/ActionType';
import { ca } from 'date-fns/locale';
import { act } from 'react-dom/test-utils';

const initialState = {
    anounList: [],
    anounDetailed: [],
    anounSeq: [],
    faqList: [],
    termsInfo: [],
    renderState: '',
    goHome: '',
    anounInxArr: [],
    reloadState: '',
    anounCnt: '',
    nimptAllList: [],
    imptAllList: [],
    disabledBtn: false,
    mtrlList: [],
    mtrlCnt: 0,
    courseCdList: [],
    ctgrCdList: [],
    gradCdList: [],
    mtrlFileList: [],
};

export default function csboardReducer(state = initialState, action) {
    switch (action.type) {
        case types.ANOUN_LIST_SUCCESS:
            return {
                ...state,
                anounImptList: action.payload.ANOUN_IMPT_LIST,
                anounNimptList: action.payload.ANOUN_NIMPT_LIST,
                anounCnt: action.payload.ANOUN_CNT
            }
        case types.ANOUN_LIST_FAILURE:
            return {
                ...state
            }
        case types.NIMPT_ANOUNALL_SUCCESS:
            return {
                ...state,
                nimptAllList: action.payload.ANOUN_NIMPT_LIST,
                imptAllList: action.payload.ANOUN_IMPT_LIST
            }
        case types.NIMPT_ANOUNALL_FAILURE:
            return {
                ...state
            }
        case types.ANOUN_DETAILED_SUCCESS:
            return {
                ...state,
                anounDetailed: action.payload,
                renderState: '2'
            }
        case types.ANOUN_DETAILED_FAILURE:
            return {
                ...state
            }
        case types.FAQ_LIST_SUCCESS:
            return {
                ...state,
                faqList: action.payload.FAQ_LIST,
            }
        case types.FAQ_LIST_FAILURE:
            return {
                ...state
            }
        case types.TERMS_CONDITIONS_SUCCESS:
            return {
                ...state,
                termsInfo: action.payload.TERMS_INFO
            }
        case types.TERMS_CONDITIONS_FAILURE:
            return {
                ...state
            }
        case types.GO_ANOUN_LIST:
            return {
                ...state,
                renderState: '1',
            }
        case types.ANOUN_ARRAY_PASS:
            return {
                ...state,
                anounInxArr: action.payload.anounInxArr,
                searchType: action.payload.searchType,
                searchTxt: action.payload.searchTxt,
                anounSeq: action.payload.seqArray,
                disabledBtn: action.payload.disabledBtn
            }

        case types.MTRL_CONDITION_SUCCESS:
            return {
                ...state,
                courseCdList: action.payload.COURSE_CD_LIST,
                ctgrCdList: action.payload.CTGR_CD_LIST,
                gradCdList: action.payload.GRAD_CD_LIST,
            }
        case types.MTRL_LIST_SUCCESS:
            return {
                ...state,
                mtrlList: action.payload.MTRL_LIST,
                mtrlCnt: action.payload.MTRL_CNT,
            }
        case types.MTRL_FILE_SUCCESS:
            return {
                ...state,
                mtrlFileList: action.payload.MTRL_FILE_LIST,
            }
        case types.SET_PAGE_RELOAD:
            return {
                ...state,
                reloadState: action.payload.reloadState
            }
        default:
            return state;
    }
}
